
import React from "react"
import { Cell } from "fixed-data-table-2"
import Icon from "app/static/frontend/components/Icon"
export const SponsorCell = ({ children, ...props }) =>
    <div className="sponsor-cell">
        {
            children
            ?  <Cell {...props}><div className="sponsor-cell-content"><Icon name={DjangIO.app.bill.models.SponsorType.by_value(parseInt(children, 10)).icon}/>{DjangIO.app.bill.models.SponsorType.by_value(parseInt(children)).label}</div></Cell>
            : <Cell {...props}>{children}</Cell>
        }
    </div>
export default SponsorCell
